import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry, Sentry } from "./lib/sentry";

initSentry();

// Mata cualquier service worker viejo que pudiera estar sirviendo chunks
// obsoletos (pantalla en blanco en hard reload) o respuestas de Supabase
// cacheadas. Se ejecuta en cada carga: es barato y garantiza que los
// navegadores afectados se limpien solos en cuanto visiten la web.
if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister().catch(() => {}));
  }).catch(() => {});
  if (typeof caches !== "undefined") {
    caches.keys().then((keys) => {
      keys.forEach((k) => caches.delete(k).catch(() => {}));
    }).catch(() => {});
  }
}

// Recuperación de la sesión ACTUAL (a diferencia de la limpieza de arriba,
// que solo evita que la PRÓXIMA carga falle): si un chunk con hash de un
// build anterior ya no existe en el servidor (típico justo tras desplegar),
// el import() dinámico de una ruta lazy falla con "Failed to fetch
// dynamically imported module" y la SPA queda a medio cargar. Vite emite
// `vite:preloadError` en ese caso — recargamos para traer el index.html e
// index de chunks actuales en vez de dejar al usuario con la app rota.
if (typeof window !== "undefined") {
  window.addEventListener("vite:preloadError", () => {
    window.location.reload();
  });
}

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary
    fallback={
      <div style={{ padding: 24, fontFamily: "system-ui, sans-serif" }}>
        <h1>Algo ha fallado</h1>
        <p>El error se ha registrado. Recarga la página o vuelve al inicio.</p>
        <button onClick={() => window.location.reload()}>Recargar</button>
      </div>
    }
  >
    <App />
  </Sentry.ErrorBoundary>
);
